import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./FloatingInput.css";
import ToastPopup from "../Toast/toastPopup";

const INVALID_CHARS_RE = /[^a-zA-Z0-9\sÀ-ɏḀ-ỿ\-'.]/;
const MIN_LENGTH = 5;
const MAX_LENGTH = 100;

const LocalizedFloatingInput = ({ showModal, handleCancel, handleConfirm, title, placeholder }) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const [inputs, setInputs] = useState({ en: "", vi: "" });

    useEffect(() => {
        if (showModal) {
            setVisible(true);
        }
    }, [showModal]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= MAX_LENGTH) {
            setInputs((prev) => ({ ...prev, [name]: value.trimStart() }));
        }
    };

    const handleCloseWithTransition = (callback) => {
        setVisible(false);
        setInputs({ en: "", vi: "" });
        setTimeout(() => {
            if (callback) {
                callback();
            }
        }, 300);
    };

    const validate = () => {
        const enVal = inputs.en.trim();
        const viVal = inputs.vi.trim();
        const activeVal = enVal || viVal;

        if (!activeVal) {
            ToastPopup.error(t("pleaseEnterCareGroupName"));
            return false;
        }
        if (INVALID_CHARS_RE.test(enVal) || INVALID_CHARS_RE.test(viVal)) {
            ToastPopup.error(t("invalidCareGroupName"));
            return false;
        }
        if (activeVal.length < MIN_LENGTH) {
            ToastPopup.error(t("careGroupNameMinLength"));
            return false;
        }
        return true;
    };

    if (!showModal && !visible) return null;

    return (
        <div className="fi-box">
            <div className={`modal-content-del reject ${visible ? "modal-open" : "modal-close"} fi-cont-box`}>
                <div className="fi-title">{t(title)} </div>
                <div className="fi-inputs-container">
                    <div className="fi-input-wrapper">
                        <label className="fi-label">{t("English")}</label>
                        <input
                            type="text"
                            name="en"
                            className="fi-input"
                            placeholder={t(placeholder)}
                            value={inputs.en}
                            onChange={handleChange}
                            maxLength={MAX_LENGTH}
                        />
                    </div>
                    <div className="fi-input-wrapper" style={{ marginTop: "1rem" }}>
                        <label className="fi-label">{t("Vietnamese")}</label>
                        <input
                            type="text"
                            name="vi"
                            className="fi-input"
                            placeholder={t(placeholder) + " (VI)"}
                            value={inputs.vi}
                            onChange={handleChange}
                            maxLength={MAX_LENGTH}
                        />
                    </div>
                </div>
                <div className="modal-footer-del reject">
                    <button className="modal-cancel-button speciality-cancel" onClick={() => handleCloseWithTransition(handleCancel)}>
                        {t("cancel")}
                    </button>
                    <button
                        className="modal-confirm-button speciality-save"
                        onClick={() => {
                            if (!validate()) return;
                            handleCloseWithTransition(() => handleConfirm(inputs));
                        }}
                    >
                        {t("create")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LocalizedFloatingInput;
